<!-- <div class="text-center">
    <ul class="steps">
        <li class="step step-primary">Enter Personal Details</li>
        <li class="step step-primary">Select Room Type</li>
        <li class="step step-primary">Proceed to Book</li>
        <li class="step step-primary">Review Booking Details</li>
    </ul>
</div> -->
<div class="grid lg:grid-flow-col lg:grid-cols-8 gap-4 mx-10">
    <div class="lg:col-span-6">
        <div class="card bg-base-100 shadow-xl">
            <ng-container [ngTemplateOutlet]="bookingCompleted"></ng-container>
        </div>
    </div>
    <div class="lg:col-span-3">
        <div class="card grow-0 bg-base-100 shadow-xl">
            <div class="card-body grow-0">
                <div>
                    <h2 class="card-title my-6">Reservation Summary</h2>
                    <div class="flex">
                        <div class="grow">
                            <div class="mb-4"><span class="text-gray-500 text-sm font-semibold">Check-In</span><br /></div>
                            <span class="font-bold text-sm mt-4"> {{ requirement.checkinDate | date : "EE, d MMMM y" }}</span
                            ><br />
                            <span class="text-sm"> From 11:00 AM </span>
                        </div>
                        <div class="grow-0 divider divider-horizontal"></div>
                        <div class="grow">
                            <div class="mb-4"><span class="text-gray-500 text-sm font-semibold">Check-Out</span><br /></div>
                            <span class="font-bold text-sm"> {{ requirement.checkoutDate | date : "EE, d MMMM y" }}</span
                            ><br />
                            <span class="text-sm"> by 9:00 AM </span>
                        </div>
                    </div>
                    <div class="mt-8">
                        <span class="text-gray-500 text-sm font-semibold">Duration of Stay: </span><br />
                        <span class="font-bold">{{ durationOfStay.days }}</span>
                        Enter svg icon
                    </div>
                    <div class="mt-8">
                        <span class="text-gray-500 text-sm font-semibold">Your Selection: </span><br />
                        <!-- Currently only single type of room is possible in a single booking -->
                        <!-- <span class="font-bold">{{ booking.bookedRooms[0].roomType.type }}</span> -->
                    </div>
                </div>
                <div class="space-y-4">
                    <h2 class="card-title mt-6">Pricing Summary</h2>
                    <div class="flex justify-between text-sm">
                        <span class="font-semibold">Rooms</span>
                        <span class="font-bold">{{ requirement.rooms || 0 }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                        <span class="font-semibold">Duration</span>
                        <span class="font-bold">{{ durationOfStay?.days || 0 }}</span>
                    </div>
                    <div class="flex justify-between text-sm text-green-600">
                        <span class="card-title font-bold">Total Price</span>
                        <span class="font-bold text-xl">{{ booking.price || 0 }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #bookingCompleted>
    <div class="card-body">
        <div>
            <div>
                <h2 class="card-title my-6">Booking Details:</h2>
                <div class="grid md:grid-cols-3 gap-4">
                    <div>
                        <label class="font-semibold space-y-2">
                            <span class="text-gray-500">GUEST</span> <br />
                            <span>{{ booking.guest.firstname }} {{ booking.guest.lastname }}</span>
                        </label>
                    </div>
                    <div>
                        <label class="space-y-2">
                            <span class="text-gray-500 font-semibold">CHECK-IN</span> <br />
                            <span class="font-semibold">{{ booking.checkinDate | date : "dd/MM/yyyy" }}</span
                            ><br />
                            <span>from 11 AM</span>
                        </label>
                    </div>
                    <div>
                        <label class="space-y-2">
                            <span class="text-gray-500 font-semibold">CHECK-OUT</span> <br />
                            <span class="font-semibold">{{ booking.checkoutDate | date : "dd/MM/yyyy" }}</span
                            ><br />
                            <span>by 9AM</span>
                        </label>
                    </div>
                    <div>
                        <label class="font-semibold space-y-2">
                            <span class="text-gray-500">YOUR RESERVATION</span> <br />
                            <span>{{ durationOfStay.days }} Nights, {{ booking.rooms }} Room(s)</span>
                        </label>
                    </div>
                    <div>
                        <label class="font-semibold space-y-2">
                            <span class="text-gray-500">PHONE NUMBER</span> <br />
                            <span>{{ booking.guest.mobile }}</span>
                        </label>
                    </div>
                    <div>
                        <label class="font-semibold space-y-2">
                            <span class="text-gray-500">BOOKING NUMBER</span> <br />
                            <!-- <span>#{{ booking.bookingNumber }}</span> -->
                            <span>{{ booking.bookingNumber }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="text-center border-solid border-1 border-gray-400 bg-gray-100 mt-4 p-8">
                <div class="space-y-4">
                    <h2 class="text-lg font-bold">Booking Voucher</h2>
                    <p class="font-semibold text-gray-500">Save this QR to save your booking information</p>
                    <div class="flex justify-center">
                        <qrcode
                            (qrCodeURL)="onChangeURL($event)"
                            [qrdata]="bookingUrl"
                            [width]="256"
                            [errorCorrectionLevel]="'M'"
                            [margin]="0"
                        ></qrcode>
                    </div>
                    <div class="text-center">
                        <a size="xl" tuiButton [href]="qrCodeDownloadLink" [download]="qrFileName">Save QR</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
